import { isString } from '../../utils';

export const useClassName = (classNames: unknown[]): string =>
  classNames
    .filter((className) => isString(className) && className.length > 0)
    .join(` `);
